export default __webpack_public_path__ + "static/media/warning.84b2f64a.svg";